import { Route, Routes } from 'react-router';

import PoliciesDetail from './PoliciesDetail';
import PoliciesOverview from './PoliciesOverview';

export default function PoliciesRoutes() {
  return (
    <Routes>
      <Route index element={<PoliciesOverview />} />
      <Route path="/:id" element={<PoliciesDetail />} />
    </Routes>
  );
}
